import styled from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
export const Container = styled.div `
  display: grid;
  grid-template-columns: ${pxToRem(120)} 1fr;
  gap: ${theme.spacing.sm} ${theme.spacing.xl};
  align-items: baseline;
`;
export const Term = styled.dt `
  font-size: ${theme.fontSize.tiny};
  color: ${theme.semantic.text[100]};
  font-weight: ${theme.fontWeight.medium};
  padding-left: ${theme.spacing.md};
`;
